<template>
  <div class="password">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="form"
      label-width="168px"
      label-position="left"
    >
      <div class="content">
        <div class="font-h1">账号密码</div>
        <div class="info" style="margin-top: 50px">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input show-password v-model="form.oldPassword"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassword">
            <el-input show-password v-model="form.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="newPasswordR">
            <el-input show-password v-model="form.newPasswordR"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div style="text-align:center;margin-left:0;">
      <base-button type="primary" @click="changePassword" style="margin-bottom: 42px">
        保存
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import { updatePassword } from "@/api/user"

export default {
  name: "Password",
  components: { BaseButton },
  data() {
    let validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原密码"))
      }
      callback()
    }
    let validateNewPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"))
      } else if (!/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/.test(value)) {
        callback(new Error("密码需为8--16位字母、数字或特殊符合至少两种组合"))
      } else if (value == this.form.oldPassword) {
        callback(new Error("新密码不可与旧密码相同"))
      }
      callback()
    }
    let validateNewPassR = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.form.newPassword) {
        callback(new Error("两次输入密码不一致!"))
      }
      callback()
    }
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        newPasswordR: ""
      },
      rules: {
        oldPassword: [{ validator: validateOldPass, trigger: "change" }],
        newPassword: [{ validator: validateNewPass, trigger: "change" }],
        newPasswordR: [{ validator: validateNewPassR, trigger: "change" }]
      }
    }
  },
  methods: {
    clearPwdForm() {
      this.form = {
        oldPassword: "",
        newPassword: "",
        newPasswordR: ""
      }
    },
    changePassword() {
      this.$refs["form"].validate(valid => {
        if (!valid) return
        updatePassword(
          encodeURIComponent(this.form.oldPassword),
          encodeURIComponent(this.form.newPassword)
        ).then(() => {
          this.$message.success("更新成功")
          this.clearPwdForm()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.password {
  .form {
    padding: 22px 312px 64px 40px;
  }
}
</style>

<style lang="scss">
.el-form-item {
  margin-bottom: 8px;
}
.el-input__inner {
  height: 36px;
}
.el-form-item__error {
  position: relative;
}
</style>
